import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import ModalCloseButton from './ModalCloseButton.jsx';
import useStickyState from './UseStickyState.jsx';

/**
 * Banner that announces there will be a downtime
 */
const DowntimeBanner = (props) => {
	const { user } = props;
	const [ closed, setClosed ] = useStickyState(false, 'downtime-banner-' + user.emailAddress);

	/**
	 * Closes the banner
	 */
	const handleClose = ()=> {
		setClosed(!closed);
	};

	return (
		<Row className={'downtime-banner' + (closed ? ' fade-out' : '')}>
			<Container>
				<Row>
					<Col xs={'12'} className={'d-flex align-center'}>
						<div className={'downtime-block'}>
							<i className={'fa-solid fa-hexagon-exclamation main-icon'}></i>
							<p><strong>Shmoop Downtime</strong><br/>
								The Shmoop website will be down for maintenance
								on <b>Friday, August 2nd</b> between the hours of <b>4:00 PM to 5:00 PM</b>
								 Pacific Daylight Time.</p>
						</div>
					</Col>
				</Row>
			</Container>
			<ModalCloseButton label={'Close'} closeFunc={handleClose} />
		</Row>
	);
};

export default DowntimeBanner;

DowntimeBanner.propTypes = {
	user: PropTypes.object
};
